import {Box, MantineProvider, Text, Title} from '@mantine/core';
import {Notifications} from '@mantine/notifications';
import type {FC} from 'react';
import {MdSchool} from 'react-icons/md';
import {routes} from '../../../config/constants';
import {GTAG_LOCATION} from '../../../config/constants/gtag';
import {useIsAppWebView} from '../../hooks/useIsAppWebView';
import {AcEmailVerificationFormContainer} from '../AcEmailVerificationForm';
import {CommonLink} from '../CommonLink';
import {GeneralFooter} from '../Footer/general';
import {GeneralHeaderContainer} from '../Header/General/container';
import {ScriptForGA} from '../ScriptForGA';

export const StudentVerificationRequiredPage: FC<{message: string}> = ({
  message,
}) => {
  const isWebView = useIsAppWebView();

  return (
    <div>
      {/* このページは _app のエラー分岐で描画されレイアウトを経由しないため、計測タグを直接読み込む */}
      <ScriptForGA />
      {!isWebView && <GeneralHeaderContainer />}
      <MantineProvider>
        <Notifications position={'top-right'} />
      </MantineProvider>
      <main>
        <Box className="flex min-h-[300px] justify-center bg-background-1 px-12 pt-16 pb-24 pc:pb-40 pc:min-h-[500px]">
          <Box className="w-full max-w-[1200px] rounded-12 bg-white px-16 py-32 shadow-card pc:px-24 pc:py-40">
            <Box className="mx-auto w-full max-w-[560px]">
              <Box className="flex flex-col items-center text-center">
                <Box className="flex h-[56px] w-[56px] items-center justify-center rounded-full bg-background-3">
                  <MdSchool size={28} className="text-primary-1" />
                </Box>
                <Title
                  order={1}
                  className="mt-16 text-lg font-bold leading text-black-1"
                >
                  {message}
                </Title>
                <Text className="mt-8 text-sm leading text-black-2">
                  在学中の大学メールアドレスを認証すると、すぐにご利用いただけます。
                </Text>
              </Box>

              <Box className="mt-24 p-0 pc:p-24">
                <AcEmailVerificationFormContainer
                  gtagLocation={GTAG_LOCATION.STUDENT_VERIFICATION_REQUIRED}
                />
              </Box>

              <Box className="mt-24 flex justify-center">
                <CommonLink
                  href={routes.HOME}
                  className="text-link text-sm leading pc:hover:opacity-80"
                >
                  トップへ戻る
                </CommonLink>
              </Box>
            </Box>
          </Box>
        </Box>
      </main>
      {!isWebView && <GeneralFooter />}
    </div>
  );
};
